import type { ResultRange } from '@/types/Search'

export const wrapSubstrings = (text: string, ranges: ResultRange[]): string => {
	if (!ranges.length) return text

	// sort from start
	const sorted = [...ranges].sort((a, b) => a.start - b.end)

	let result = ''
	let lastIndex = 0

	for (const { start, end, active } of sorted) {
		// skip if indexes are corrupted
		if (start < lastIndex) continue

		result += text.slice(lastIndex, start)

		const target = text.slice(start, end)
		result += `<span class="highlight ${
			active ? 'active' : ''
		}">${target}</span>`

		lastIndex = end
	}

	result += text.slice(lastIndex)

	return result
}
